<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LgxSrr/tc-custom/9781250022783.jpg?1737766217798" alt="This image is the cover for the book Scratchgravel Road, Josie Gray Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scratchgravel Road, Josie Gray Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>The twisty follow-up to the Hillerman Prize–winning <i>The Territory,</i> featuring tough smalltown Texas police chief Josie Gray<br/><br/>It was pure luck that Josie Gray spotted Cassidy Harper's car, abandoned on the side of the road. If she hadn't, then she'd never have found Cassidy, lying nearly dead of heatstroke on the desert sand beside the body of a Mexican immigrant. But Cassidy can't explain why she was out for a walk in the midday desert heat, let alone how she happened upon the corpse. And once Josie sees the ominous wounds on the man's body, she knows she needs to find the answer fast, before her own life is in danger.<br/><br/>Tricia Fields's <i>The Territory </i>marked her as talented new author of Southwestern crime, and <i>Scratchgravel Road </i>marks an inventive new mystery set in the unique world of smalltown Texas.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tricia Fields
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?10413588